export type GoogleCalendarProps = {
  id?: string;
  calendarId: string;
  width?: string;
  height?: string;
  wkst?: number;
  ctz?: string;
  hl?: string;
  mode?: 'WEEK' | 'MONTH' | 'AGENDA';
  showTitle?: boolean;
  showNav?: boolean;
  showPrint?: boolean;
  showDate?: boolean;
  showTabs?: boolean;
  showCalendars?: boolean;
  showTz?: boolean;
  color?: string;
};

export const defaults = {
  width: "800",
  height: "600",
  wkst: 2,
  ctz: "Europe/Moscow",
  hl: "ru",
  showTitle: true,
  showNav: true,
  showPrint: true,
  showDate: true,
  showTabs: true,
  showCalendars: true,
  showTz: true
};
